module.exports = new __parcel__URL__("Frame-7.78e0fbe2.svg").toString();